import type React from 'react';

import { Button, HeroLayout, Image, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { PetitionGuideResetCacheButton } from '#src/app/shared/components/petitionGuides';

import { usePageHeading } from './hooks/usePageHeading';

export const PageHeading: React.FC<EmptyProps> = () => {
	const {
		data: { title, description, image, sapAiUrl, sapUrl },
		actions: { trackSapClick, trackSapAiClick },
	} = usePageHeading();

	return (
		<div className="container pt-10 md:pt-16">
			<PetitionGuideResetCacheButton />
			<HeroLayout
				media={<Image src={image.url} className="h-full w-full rounded-2xl object-cover" alt={image.alt} />}
				reverseMd
				reverseSm
				variant="1/3"
			>
				<div className="flex flex-col gap-7 pb-6 md:pr-7 md:pb-0">
					<Text variant="display" className="m-0 max-w-[600px]" as="h1">
						{title}
					</Text>
					<Text variant="body" size="large">
						{description}
					</Text>
					<div className="flex w-full gap-4 max-lg:flex-col">
						<Button
							as="a"
							href={sapUrl}
							variant="primary"
							size="large"
							className="max-w-none max-lg:w-full"
							data-qa="hero-sap-button"
							onClick={trackSapClick}
						>
							<Translate value="corgi.petition_guides_landing_page.page_heading.start_a_petition" />
						</Button>
						<Button
							as="a"
							href={sapAiUrl}
							variant="secondary"
							size="large"
							data-qa="hero-ai-sap-button"
							className="max-w-none max-lg:w-full"
							onClick={trackSapAiClick}
						>
							<Translate value="corgi.petition_guides_landing_page.page_heading.get_started_ai" />
						</Button>
					</div>
				</div>
			</HeroLayout>
		</div>
	);
};
